__turbopack_context__.v({
  "actions": "package-card-module__7tsSjW__actions",
  "duration": "package-card-module__7tsSjW__duration",
});
